<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline title="Approved Product Retailer Margin">
      <v-card-actions>
        <button @click="$router.go(-1)">
          <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" color="white" absolute top right>
            <v-icon left>mdi-arrow-left</v-icon>back
          </v-btn>
          <v-btn v-else absolute right top fab small color="grey lighten-2" elevation="1" class="mr-4 mt-12"
            style="opacity: 0.6">
            <v-icon>mdi-arrow-left</v-icon></v-btn>
        </button>
      </v-card-actions>
      <v-card-component>
        <v-card-text class="pt-0 pr-1" :class="{
          'd-block py-3': $vuetify.breakpoint.xs,
          'd-flex align-center': $vuetify.breakpoint.smAndUp
        }">
          <v-card-title>Total Records: {{ total }}</v-card-title>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="mdi-magnify" class="ml-auto mb-2" label="Search" hide-details
            single-line style="max-width: 350px;" :class="{
              'mr-0': $vuetify.breakpoint.xs,
              'mr-5': $vuetify.breakpoint.smAndUp
            }" @input="searchData" />
        </v-card-text>
        <v-divider class="my-0" />
        <v-data-table :headers="headers" :items="productList" disable-pagination :hide-default-footer="true"
          class="elevation-3">
          <!-- <template v-slot:item.actions="{ item }">
            <router-link :to="{
              name: 'updateProduct',
              params: { productID: item.productID }
            }">
              <v-btn class="px-1 ml-1 mb-1" outlined color="accent" small>
                <v-icon class="mr-2" x-small>mdi-pencil</v-icon>Edit
              </v-btn>
            </router-link>

          </template> -->
          <template v-slot:no-data>
            <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
          </template>
        </v-data-table>
        <v-col>
          <v-row>
            <v-col cols="4" sm="3">
              <v-select v-model="pageSize" :items="pageSizes" label="Items per Page"
                @change="handlePageSizeChange"></v-select>
            </v-col>
            <v-col cols="12" sm="9">
              <v-pagination v-model="page" navigation-text-color="accent" color="accent" :length="totalPages"
                :total-visible="10" @input="handlePageChange" />
            </v-col>
          </v-row>
        </v-col>
      </v-card-component>
    </material-card>
    <loading-icon :value="isLoading" />
  </v-container>
</template>
<script>
import VCardComponent from '@/components/template/VCardComponent'
import MaterialCard from '@/components/template/MaterialCard'
import constants from '@/utils/constants'
import { mapGetters } from 'vuex'
export default {
  name: 'approvedProductRetailerMarginList',
  components: {
    MaterialCard,
    VCardComponent
  },
  data () {
    return {
      productList: [],
      total: 0,
      page: 1,
      totalPages: 0,
      pageSize: 10,
      pageSizes: [10, 20, 50, 100],
      data: [],
      search: '',
      isLoading: false,
      loadingComponent: null,
      academicYears: [],
      academicYearID: '',
      headers: [
        { text: 'SR.NO', value: 'srno', sortable: true, align: 'center' },
        {
          text: 'Product ID',
          value: 'productID',
          sortable: true,
          align: 'center'
        },
        {
          text: 'Discount To Parent',
          value: 'discountToParent',
          sortable: true,
          align: 'center'
        },
        {
          text: 'Retailer Margin',
          value: 'retailerMargin',
          sortable: true,
          align: 'center'
        }
        // { text: 'Action', value: 'actions', sortable: false, align: 'center' }
      ]
    }
  },
  async created () {
    // this.page = parseInt(this.$route.params.current)
    this.page = 1
    await this.getProductList()
    await this.onFranchiseeChange()
  },
  watch: {
    franchisee: async function () {
      await this.onFranchiseeChange()
    },
    academicYear: async function () {
      await this.onFranchiseeChange()
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  methods: {
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        this.inProgress = false
      }
    },
    getProductList: async function () {
      try {
        const response = await http.get(
          `${constants.API_URL}/api/product/getProductDetailsList?page=${this.page - 1
          }&size=${this.pageSize}&search=${this.search}`
        )
        this.data = response.data
        this.productList = this.data.rows
        this.total = this.data.totalItems
        this.productList.filter((item, index) => {
          item.srno = this.pageSize * (this.page - 1) + index + 1
        })
        this.totalPages = this.data.totalPages
        this.isLoading = false
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching product list', errorMessage)
      }
    },
    searchData () {
      if (this.search) {
        this.page = 1
        this.getProductList()
      } else {
        this.getProductList()
      }
    },
    handlePageChange (value) {
      this.page = value
      this.$router.push({
        name: 'approvedProductRetailerMarginList',
        params: { current: this.page }
      })
      this.getProductList()
      this.isLoading = true
    },
    handlePageSizeChange (size) {
      this.pageSize = size
      this.page = 1
      this.getProductList()
    },

    okMsg (msg) {
      return this.$dialog.info({
        title: 'Success',
        text: msg
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
